import EbookContainer from './EbookContainer';

export default EbookContainer;
